import React from 'react';

import { Table } from 'components/MRT';

import { MarketStatsData } from '../../types';
import { totalTableColumns } from './totalsTableColumns';

export function TotalsTable({ data }: { data: MarketStatsData[] }) {
  const pageSize = 5;
  const displaysFiltersAndPagination = data.length > pageSize;

  const isAaveAPRs = data.some(column => column.stableBorrowAPY || column.variableBorrowAPY);

  return (
    <Table<MarketStatsData>
      initialState={{
        density: 'compact',
        columnVisibility: {
          lowSupply: false,
          borrowAPY: !isAaveAPRs,
          variableBorrowAPY: isAaveAPRs,
        },
        columnFilters: data.length > pageSize ? [{ id: 'lowSupply', value: false }] : [],
        columnOrder: [
          'asset',
          'utilizationRatio',
          'supplyAPY',
          'borrowAPY',
          'variableBorrowAPY',
          'totalTvl',
          'totalBorrow',
          'totalCollateral',
          'lowSupply',
        ],
        displaySettings: {
          fallbackedTotalUSDVariant: 'value',
        },
        pagination: {
          pageIndex: 0,
          pageSize,
        },
      }}
      autoPinningColumns={['asset']}
      data={data}
      columns={totalTableColumns}
      enablePagination={displaysFiltersAndPagination}
      enableColumnFilterModes
      enableFilters={displaysFiltersAndPagination}
      withFullScreenButton
      enablePinning={false}
      enableToolbarInternalActions={false}
      enableTopToolbar={false}
    />
  );
}
